module.exports = __webpack_public_path__ + "img/icon_paihang.632827b5.gif";